import {
	Alert,
	Box,
	Button,
	Container,
	Divider,
	Icons,
	Spinner,
	Stack,
	Text,
} from "@sembark-travel/ui/base"
import { Breadcrumbs } from "@sembark-travel/ui/router"
import { Helmet } from "react-helmet-async"
import {
	PaymentGatewayIntegratedAppConfiguration,
	useFetchIntegration,
	useFetchPaymentGatewayIntegratedApp,
} from "./../../../../Integrations"
import { generatePath, useParams, useNavigate } from "../../../../router-utils"
import {
	Form,
	SubmissionError,
	SwitchInputField,
	withServerErrors,
} from "@sembark-travel/ui/form"
import { isTruthy } from "remeda"

export default function EditIntegrationPage() {
	const { integrationId } = useParams("/integrations/:integrationId")
	const navigate = useNavigate()
	const {
		data: integration,
		error: integrationError,
		isValidating: integrationFetching,
	} = useFetchIntegration(integrationId)

	const {
		data: pgIntegratedApp,
		error: pgIntegratedAppError,
		isValidating,
	} = useFetchPaymentGatewayIntegratedApp(integration?.integrated_app_id)

	if (!pgIntegratedApp || !integration) {
		if (isValidating || integrationFetching) {
			return <Spinner alignCenter />
		}

		const error = pgIntegratedAppError || integrationError

		return (
			<Alert status="error">
				{error.message || "Something went wrong. Please try after sometime."}
			</Alert>
		)
	}

	return (
		<>
			<Helmet>
				<title>New Integration</title>
			</Helmet>
			<Breadcrumbs
				title="Configuration"
				items={[
					[generatePath("/org/integrations"), "Integrations"],
					[
						generatePath("/integrations/:integrationId/pg", {
							integrationId: integrationId,
						}),
						integration.name,
					],
					["", "Configuration"],
				]}
			/>

			<Box paddingX={{ md: "4" }} paddingY={{ md: "8" }}>
				<Box maxWidth="3xl" marginX="auto">
					<Box borderWidth={{ md: "1" }} rounded="md" bgColor="default">
						<Container paddingY="6">
							<PaymentGatewayIntegratedAppConfiguration
								webhookUrls={pgIntegratedApp.meta.webhook_urls}
							/>
							<Divider />
							<Form
								initialValues={{ confirmed: 0 }}
								onSubmit={withServerErrors(async (values) => {
									const { confirmed } = values
									if (!isTruthy(confirmed)) {
										throw new Error(
											"Please confirm that you have configured the webhooks by selecting the checkbox."
										)
									}
									navigate("/integrations/:integrationId/pg", {
										params: {
											integrationId: integrationId,
										},
									})
								})}
							>
								{({ handleSubmit }) => (
									<form onSubmit={handleSubmit} noValidate>
										<Stack gap="4">
											<Alert status="warning" title="Webhook setup is required">
												<Text>
													Webhook setup is required for system to process the
													payments. If not setup properly, the system will NOT
													be able to receive the payment acknowledgement from
													the payment gateway for secure payment transaction.
												</Text>
											</Alert>
											<Box
												padding="4"
												bgColor="primary"
												borderWidth="1"
												borderColor="primary"
											>
												<SwitchInputField
													name="confirmed"
													label="I have completed the webhook configuration"
												/>
											</Box>
											<SubmissionError />
											<Box>
												<Button
													type="submit"
													level="secondary"
													status="primary"
												>
													<Icons.Ok /> Done
												</Button>
											</Box>
										</Stack>
									</form>
								)}
							</Form>
						</Container>
					</Box>
				</Box>
			</Box>
		</>
	)
}
